import { render, staticRenderFns } from "./TrafficLocationsMap.vue?vue&type=template&id=e2137b06&"
import script from "./TrafficLocationsMap.vue?vue&type=script&lang=js&"
export * from "./TrafficLocationsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports